import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShoppingBag4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="shopping-bag-4" maskId="round-filled-radius-0-stroke-1.5-IconShoppingBag4"><path fillRule="evenodd" clipRule="evenodd" d="M17 7H20.25C20.6642 7 21 7.33579 21 7.75V17.25C21 19.3211 19.3211 21 17.25 21H6.75C4.67893 21 3 19.3211 3 17.25V7.75C3 7.33579 3.33579 7 3.75 7H7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7ZM12 3.5C10.067 3.5 8.5 5.067 8.5 7H15.5C15.5 5.067 13.933 3.5 12 3.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShoppingBag4;
